import React, { useState } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";

export default function EditQuize({ quize }) {
  const {
    id,
    question: initialQuize,
    video_id: initialVideoId,
    video_title: initialVideoTitle,
    options: initialOptions,
  } = quize;

  const [question, setQuestion] = useState(initialQuize);
  const [videoId, setVideoId] = useState(initialVideoId);
  const [videoTitle, setVideoTitle] = useState(initialVideoTitle);
  const [quizeOption, setQuizeOption] = useState(initialOptions);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const addFields = () => {
    let newfield = { option: "", isCorrect: false };
    setQuizeOption([...quizeOption, newfield]);
  };
  const removeFields = (index) => {
    let data = [...quizeOption];
    data.splice(index, 1);
    setQuizeOption(data);
  };

  const handleInput = (e) => {
    let inputValue = "";
    switch (e.target.type) {
      case "text":
        inputValue = e.target.value;
        break;
      case "number":
        inputValue = e.target.value === "" ? "" : Number(e.target.value);
        break;
      case "checkbox":
        inputValue = e.target.checked;
        break;
      case "select-one":
        inputValue = e.target.value == "true" ? true : false;
        break;
      default:
        break;
    }
    return inputValue;
  };

  const handleOption = (index, event) => {
    let data = [...quizeOption];
    let name = event.target.name;
    let value = handleInput(event);
    data[index][name] = value;
    data[index]["id"] = 1;
    setQuizeOption(data);
    console.log(data);
  };

  const optionsSelect = (e) => {
    setVideoId(e.target.value);
    setVideoTitle(e.target.selectedOptions[0].childNodes[0].data);
  };

  let option = null;
  const { data, isLoading, isError } = useGetVideosQuery();
  if (!isLoading && data)
    option = data.map((video, i) => (
      <option key={i} value={video.id}>
        {video.title}
      </option>
    ));

  return (
    <form className="video-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label>Select Video</label>
        <select
          name="video"
          className="text-input"
          value={videoId}
          onChange={optionsSelect}
        >
          <option hidden>Choose Video</option>
          {option}
        </select>
      </div>
      <div className="space-y-2">
        <label>Question</label>
        <input
          required
          className="text-input"
          type="text"
          name="question"
          value={question}
          placeholder="Enter Quize Question"
          onChange={(e) => setQuestion(e.target.value)}
        />
      </div>

      {quizeOption.map((input, index) => (
        <div
          key={index}
          className="grid grid-cols-2 gap-8 pb-4"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "flex-end",
          }}
        >
          <div className="space-y-2" style={{ width: "70%" }}>
            <label>Quize Option</label>
            <div>
              <input
                required
                className="text-input"
                type="text"
                name="option"
                placeholder="Enter Quize Option"
                value={input.option}
                onChange={(event) => handleOption(index, event)}
              />
            </div>
          </div>
          <div className="space-y-2" style={{ width: "25%" }}>
            <label>Answer</label>
            <div>
              <select
                required
                className="text-input"
                name="isCorrect"
                value={input.isCorrect}
                onChange={(event) => handleOption(index, event)}
              >
                <option value={false}>False</option>
                <option value={true}>True</option>
              </select>
            </div>
          </div>
          <div
            className="space-y-2"
            style={{ marginBottom: "5px", cursor: "pointer" }}
            onClick={() => removeFields(index)}
          >
            X
          </div>
        </div>
      ))}
      <div
        className="text-center"
        onClick={addFields}
        style={{
          marginBottom: "20px",
          background: "rgb(59 130 246 / 0.5)",
          borderRadius: "20px",
          cursor: "pointer",
        }}
      >
        Add more
      </div>

      <button
        // disabled={addQuizeLoading}
        type="submit"
        className="submit"
        id="lws-submit"
      >
        Add Quize
      </button>
      <div>
        {/* {addQuizeSuccess && (
          <p className="text-center" style={{ color: "green" }}>
            Quize add successfully
          </p>
        )}
        {addQuizeError && (
          <p className="text-center" style={{ color: "red" }}>
            There was an error
          </p>
        )} */}
      </div>
    </form>
  );
}
